import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { Region } from "store/home/home.model";
import type { Track } from "store/track/track.model";
import type { User } from "store/user/user.model";

interface CurrentUser {
  auth: string | null;
  user: User | null;
  registrationKey: string | null;
  password: string | null; // it's a temporary state only for registration flow
  region: Region;
}

const initialState: CurrentUser = {
  auth: null,
  user: null,
  registrationKey: null,
  password: null,
  region: "all",
};

export const currentUserSlice = createSlice({
  name: "currentUser",
  initialState,
  reducers: {
    setAuth: (state, action: PayloadAction<string | null>) => {
      state.auth = action.payload;
    },
    setUser: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload;
    },
    setRegistrationKey: (state, action: PayloadAction<string | null>) => {
      state.registrationKey = action.payload;
    },
    setPassword: (state, action: PayloadAction<string | null>) => {
      state.password = action.payload;
    },
    setRegion: (state, action: PayloadAction<CurrentUser["region"]>) => {
      state.region = action.payload;
    },
  },
});

export const { reducer: currentUserReducer, actions: currentUserActions } =
  currentUserSlice;
